import { createAction } from "redux-act";

export const OpenEditPhaseModalAction = createAction("Edit Phase - Open Modal");
export const CloseEditPhaseModalAction = createAction("Edit Phase - Close Modal");
